<template>
  <ViewContainer>
    <v-row>
      <v-col md="10" offset-md="1" class="mt-16">
        <v-row>
          <v-col>
            <img class="pb-4 mt-10" :src="image" alt="empty_state_404" />
          </v-col>
          <v-col class="align-self-center">
            <div>
              <p class="h3 font-bold mb-4">{{ defaultTitle }}</p>
              <p class="body-1 gray--text mb-6">
                {{ defaultText }}
              </p>
              <Button
                :to="defaultAction.to"
                :color="defaultAction.color"
                :text="defaultAction.text"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </ViewContainer>
</template>

<script>
import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import Button from '@/components/UI/Button'
import image from '@/assets/images/empty-states/satellite-empty-state.svg'

export default {
  name: 'error404',

  components: {
    ViewContainer,
    Button,
  },

  props: {
    title: String,
    text: String,
    action: Object,
  },

  data() {
    return {
      image,
    }
  },

  mounted() {
    this.$store.dispatch('hideLoader')
  },

  computed: {
    defaultAction() {
      return {
        to: this.action?.to ?? '/home',
        color: this.action?.color ?? 'primary',
        text: this.action?.text ?? this.$t('common.go_back_to_home'),
      }
    },

    defaultTitle() {
      return this.title ?? this.$t('error.404.title')
    },

    defaultText() {
      return this.text ?? this.$t('error.404.subtitle')
    },
  },
}
</script>
